module.exports = __webpack_public_path__ + "img/sponsorAM2022.55345cd3.png";